
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"preserveAspectRatio":"none","viewBox":"0 0 662 345","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M662 156H300v112h362v-4H303.967V160H662v-4zM514 345v-30H300v30h4v-26h206v26h4z","fill":"#30C07C"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M662 2H2v343h4V6h656V2z","fill":"#484848"}}),_c('path',{attrs:{"fill":"#C6EED1","d":"M658 0h4v7h-4zM0 0h7v7H0zM0 341h7v4H0z"}})])
          )
        }
      }
    